var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#75FB4C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.67-102.67q-106 0-180-74t-74-180v-246.66q0-106 74-180t180-74h246.66q106 0 180 74t74 180v246.66q0 106-74 180t-180 74H356.67ZM439.33-310l253.34-253.33-59.34-59.34-194 194L344-524l-59.33 59.33L439.33-310Zm-82.66 123.33h246.66q71 0 120.5-49.5t49.5-120.5v-246.66q0-71-49.5-120.5t-120.5-49.5H356.67q-71 0-120.5 49.5t-49.5 120.5v246.66q0 71 49.5 120.5t120.5 49.5ZM480-480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done-icon.79d506634bcd79ea64fa8544588da6c6.svg";
export { ForwardRef as ReactComponent };